// LUMINA · pages/vajra/components/DharmaLineagePage.jsx
// Phase 39D: extracted from VajraPortal.jsx

import React, { useState, useEffect } from 'react';
import { API } from '../constants';
import LineageCard from './LineageCard';

export default function DharmaLineagePage({ member, setTab }) {
  const LINEAGES = [
    {key:"dzogchen",name_zh:"大圆满",name_en:"Dzogchen · Great Perfection",teacher:"拉则祖古仁波切",teacher_en:"Tulku Lhatse Rinpoche",tradition:"宁玛派",color:"#3730a3",bg:"rgba(55,48,163,0.06)",border:"rgba(55,48,163,0.18)",avatar:"🌅",intro:"大圆满（藏：རྫོགས་ཆེན，Dzogchen）为宁玛派最高密法，直指心性本来面目——开放、明亮、无遮的觉性。此传承经由莲花生大师传至西藏，历代上师心心相传，不落文字。",practices:["彻却（直断）修持","脱噶（顿超）观修","觉性禅定（本觉安住）","前行四加行"],mantra:"嗡 阿 吽 班扎 古汝 贝玛 悉地 吽",mantra_note:"莲师心咒 — 大圆满传承根本上师",note:"此法门以上师直指为核心，需在具德上师引导下修持。",initiation_key:null},
    {key:"naropa",name_zh:"那若六法 · 扎龙",name_en:"Naropa's Six Yogas · Tummo",teacher:"堪仁波切昆桑格西",teacher_en:"Lama Kunsang",tradition:"噶举派",color:"#1e3a5f",bg:"rgba(30,58,95,0.06)",border:"rgba(30,58,95,0.18)",avatar:"🔥",intro:"那若六法为噶举派核心密法，由印度大成就者那若巴传承至玛尔巴，再经米拉日巴传至今日。扎龙（拙火/灵热）为六法之基，以生命能量净化脉轮，融合空乐无别之境。",practices:["拙火（灵热/扎龙）修持","幻身法","梦瑜伽","明光瑜伽","中阴成就法","迁识（颇瓦）法"],mantra:"嗡 玛尼 贝美 吽 舍",mantra_note:"观世音心咒 — 慈悲与菩提心基础",note:"那若六法以体脉明点修持为主，须具备前行基础方可修习。",initiation_key:null},
    {key:"vajrakilaya",name_zh:"普巴金刚",name_en:"Vajrakilaya · Diamond Dagger",teacher:"拉则祖古仁波切",teacher_en:"Tulku Lhatse Rinpoche",tradition:"宁玛派",color:"#6B1A1A",bg:"rgba(107,26,26,0.06)",border:"rgba(107,26,26,0.18)",avatar:"🗡",intro:"普巴金刚（Vajrakilaya）为宁玛派最重要的忿怒护法本尊，以金刚橛（普巴）斩断三毒根本障碍，清除修行道上一切违缘与邪障，是藏传佛教中力量最猛烈的息增怀诛法门之一。",practices:["普巴金刚仪轨修持","金刚橛咒修誦","忿怒莲师荟供","障碍清净法"],mantra:"嗡 班扎 格里 格里拉 班扎 萨埵 皆 吽 啪的",mantra_note:"普巴金刚心咒",note:"修持普巴金刚须具足灌顶传承，以猛厉悲心与空性见为基础。",initiation_key:"Yamantaka"},
    {key:"tara",name_zh:"如意珠度母",name_en:"Cintachakra Tara · Wish-Fulfilling Tara",teacher:"堪仁波切格西嘉滇",teacher_en:"Khen Rinpoche Geshe Jaden",tradition:"格鲁派",color:"#064E3B",bg:"rgba(6,78,59,0.06)",border:"rgba(6,78,59,0.18)",avatar:"🪷",intro:"如意珠度母（Cintachakra Tara）为白度母之特殊化身，以如意珠为标志，能满足行者世出世间一切愿望，特别加持长寿、智慧与顺缘具足。此传承经由格西嘉滇仁波切亲传，法脉清净。",practices:["如意珠度母仪轨","白度母长寿修持","二十一度母礼赞文"],mantra:"嗡 达瑞 都达瑞 都瑞 梭哈",mantra_note:"度母心咒 — 迅速救度，消除一切障难",note:"度母法门慈悲广大，适合各级修行者，以信心与清净心修持最为相应。",initiation_key:"GreenTara"},
  ];
  const [teachings, setTeachings] = useState([]);
  useEffect(()=>{
    fetch(`${API}/vajra/teachings`).then(r=>r.ok?r.json():[]).then(setTeachings).catch(()=>{});
  },[]);

  return (
    <div style={{paddingTop:28,paddingBottom:40}}>
      {/* Page Header */}
      <div style={{textAlign:"center",marginBottom:32}}>
        <div style={{fontSize:11,color:"#aaa",letterSpacing:3,textTransform:"uppercase",marginBottom:8}}>
          Vajra Community · Sacred Lineage
        </div>
        <h2 style={{margin:"0 0 10px",fontSize:22,color:"#1a1a1a",fontFamily:"'Noto Serif SC',serif",fontWeight:600}}>
          密法传承
        </h2>
        <p style={{margin:0,fontSize:13,color:"#888",maxWidth:480,marginLeft:"auto",marginRight:"auto",lineHeight:1.75}}>
          以下为如意宝金刚社群现持传承，每一法脉皆源自具德上师之心心相传。
          愿诸弟子善护传承，精进修持，以利益一切有情。
        </p>
      </div>

      {/* Lineage Cards */}
      {LINEAGES.map(l => {
        const teaching = teachings.find(t=>t.title_zh&&l.name_zh&&t.title_zh.includes(l.name_zh.split("·")[0].trim()));
        return <LineageCard key={l.key} lineage={l} member={member} setTab={setTab} teaching={teaching}/>;
      })}

      {/* Footer Note */}
      <div style={{
        marginTop:8,padding:"14px 18px",
        background:"rgba(0,0,0,0.02)",borderRadius:10,
        border:"1px solid rgba(0,0,0,0.06)",
        fontSize:12,color:"#aaa",lineHeight:1.8,textAlign:"center",
      }}>
        如需了解灌顶传承详情，请联系如意宝群管理员。<br/>
        一切法门须在具德上师指导下修持，不可单凭文字擅自修习。
      </div>
    </div>
  );
}
